import difference from 'lodash/difference';
import { track, AmplitudeCustomEvents } from '@/lib/amplitude';
import type { UserAssignSelectRole } from '@/features/User/types';
import { type Role } from '@/generated/graphql';

interface TrackTaskAssigneeChangesParams {
	roles: UserAssignSelectRole[];
	currentRoleIds: Role['id'][];
}

export const trackRoleAssigneeChanges = ({
	roles,
	currentRoleIds,
}: TrackTaskAssigneeChangesParams) => {
	const newRoleIds = roles.map((role) => role.id);

	const addedRoleIds = difference(newRoleIds, currentRoleIds);

	addedRoleIds.forEach(() => {
		track(AmplitudeCustomEvents.RoleAddedToTask);
	});
};

export const trackRoleReplacement = () => {
	track(AmplitudeCustomEvents.RoleReplacedWithUser);
};
